import React from 'react';
import AnchorLink from "../components/AnchorLinkComponent";
import BaseSizeSensitiveComponent from "../components/BaseSizeSensitiveComponent";

class MyApps extends BaseSizeSensitiveComponent {
    render() {

        var myAppsContainer = {
            width: "100%",
            alignText: "center",
            alignContent: "center",
            display: "flex",
            justifyContent: "center",
            flexWrap: "wrap"
        }


        return (
            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>My Apps:</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>You can find my personal Apps below:</p>
                        <ul >
                            <li><AnchorLink value="My personal Android Apps" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/myapps/android'/></li>
                            <li><AnchorLink value="My personal iOS Apps" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/myapps/ios'/></li>
                            <li><AnchorLink value="My other apps" style={this.styler.currStyles.Body.TextPage.Section.anchor} pushTo='/myapps/other'/></li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default MyApps


// WEBPACK FOOTER //
// src/Apps/MyApps.js